<template>
  <div>

    <v-navigation-drawer v-model="drawer" clipped app v-if="isAuthenticated()">
      <v-list dense>
        <template v-for="item in toolbarItems">
          <ToolbarNavMenu v-if="hasAccess(item)" :item="item" :key="item.text" />
        </template>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar clipped-left dark app color="secondary" style="padding-left: 0">
      <v-app-bar-nav-icon v-if="isAuthenticated()" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title :class="{'white--text': true, 'ml-0': isAuthenticated()}">
        <span>{{getAppName}}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <span v-if="isAuthenticated()">{{getUserName()}}</span>
      <v-menu max-width="62" style="padding-right: 12px">
        <template v-slot:activator="{ on }">
          <v-app-bar-nav-icon v-on="on">
            <v-img :src="getCurrentFlag()" contain max-height = 25></v-img>
          </v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item v-for="item in getSupportedLang" :key="item.lang" @click="setLang(item.lang)">
            <v-list-item-avatar tile size="30"><img :src="item.flag"></v-list-item-avatar>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn v-if="toggleButton() === 'about'" icon :to="{name: 'about'}">
        <v-icon>help</v-icon>
      </v-btn>
      <v-btn v-else-if="toggleButton() === 'login'" icon :to="{name: 'login'}">
        <v-icon>account_circle</v-icon>
      </v-btn>
      <v-btn v-else-if="toggleButton() === 'logout'" icon @click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>

  </div>
</template>

<script>
import { app } from '@/main'
import ToolbarNavMenu from './ToolbarNavMenu'
import * as Security from '@/core/security'
import * as Lang from '@/core/lang'
import * as License from '@/core/license'

import SVGIcons from '@/assets/svg/SVGIcons'

export default {
  components: {
    ToolbarNavMenu
  },
  data () {
    return {
      drawer: false,
      toolbarItems: [
        // Icon is material icon, text is displayed next to it and route is
        // optional that defines if it should navigate somewhere.
        // Item is hidden if user does not have a valid claim.
        // Icons: https://material.io/tools/icons/?style=baseline
        {
          icon: 'home',
          text: 'Welcome',
          route: { name: 'welcome' }
        },
        {
          icon: 'local_shipping',
          text: 'Delivery inspection',
          claims: [License.deliveryInspectionNo],
          route: { name: 'registrations' }
        },
        {
          icon: SVGIcons.WheelLoaderIcon,
          isCustomIcon: true,
          text: 'Wheel loader',
          claims: [License.wheelLoaderNo],
          route: { name: 'wheel-loader-registrations' }
        },
        {
          icon: 'how_to_reg',
          text: 'Pre-registration',
          claims: [License.preRegistrationNo],
          route: { name: 'pre-registration-registrations' }
        },
        {
          icon: 'category',
          text: 'Classifier',
          claims: [License.classifierNo],
          route: { name: 'classifier-registrations' }
        },
        {
          icon: 'mdi-barcode',
          text: 'Scan Code',
          claims: [License.scanCodeNo],
          children: [
            {
              icon: 'topic',
              text: 'scan-code-registrations',
              claims: [License.scanCodeNo],
              route: { name: 'scan-code-registrations' }
            },
            {
              icon: 'mdi-barcode',
              text: 'scan-code-deliveries',
              claims: [License.scanCodeNo],
              route: { name: 'scan-code-deliveries' }
            }
          ]
        },
        {
          icon: 'add_road',
          text: 'Asphalt delivery',
          claims: [License.asphaltDeliveryVehicleNo, License.asphaltDeliveryCarrierNo],
          children: [
            {
              icon: 'topic',
              text: 'Deliveries',
              claims: [License.asphaltDeliveryVehicleNo, License.asphaltDeliveryCarrierNo],
              route: { name: 'asphalt-delivery' }
            },
            {
              icon: 'local_shipping',
              text: 'Vehicles',
              claims: [License.asphaltDeliveryCarrierNo],
              route: { name: 'asphalt-delivery-vehicles' }
            }
          ]
        },
        {
          icon: SVGIcons.NominationIcon,
          isCustomIcon: true,
          text: 'Nominations',
          claims: [License.nominationNo],
          route: { name: 'nominations' }
        },
        {
          icon: 'local_gas_station',
          text: 'Unloading Fuel',
          claims: [License.unloadingFuelNo],
          route: { name: 'unloading-fuel' }
        },
        {
          icon: 'line_weight',
          text: 'Batch registration',
          claims: [License.batchRegistrationNo],
          route: { name: 'batch-registration' }
        },
        {
          icon: 'mdi-cellphone',
          text: 'Scan Mobile',
          claims: [License.scanMobileNo],
          route: { name: 'scan-mobile-registrations' }
        },
        {
          // icon: 'mdi-image',
          icon: 'mdi-image-filter-hdr',
          text: 'Storage Map',
          claims: [License.storageMapNo],
          children: [
            {
              icon: 'mdi-earth',
              text: 'Map',
              claims: [License.storageMapNo],
              route: { name: 'storage-map' }
            }
          ]
        },
        {
          icon: 'local_shipping',
          text: 'Create Vehicles',
          claims: [License.createVehiclesNo],
          route: { name: 'create-vehicles' }
        },
        {
          icon: 'topic',
          text: 'Deliveries',
          claims: [License.worlPlacesNo],
          route: { name: 'workplaces' }
        },
        {
          icon: 'receipt',
          text: 'Reports',
          claims: [License.reportsNo, License.reportsSimpleNo],
          children: [
            {
              icon: 'local_shipping',
              text: 'Registrations',
              claims: [License.reportsNo],
              route: { name: 'reports-registrations' }
            },
            {
              icon: 'local_shipping',
              text: 'Registrations Simple',
              claims: [License.reportsSimpleNo],
              route: { name: 'reports-registrations-simple' }
            }
          ]
        },
        {
          icon: 'build',
          text: 'Administration',
          claims: [License.adminNo, License.corporateAdminNo],
          children: [
            {
              icon: 'business',
              text: 'Corporations',
              claims: [License.adminNo],
              route: { name: 'corporations' }
            },
            {
              icon: 'account_tree',
              text: 'Facilities',
              claims: [License.adminNo, License.corporateAdminNo],
              route: { name: 'facilities' }
            },
            {
              icon: 'people',
              text: 'User Groups',
              claims: [License.adminNo, License.corporateAdminNo],
              route: { name: 'usergroups' }
            },
            {
              icon: 'person',
              text: 'Users',
              claims: [License.adminNo, License.corporateAdminNo],
              route: { name: 'users' }
            },
            {
              icon: 'settings',
              text: 'System',
              claims: [License.adminNo],
              route: { name: 'system' }
            },
            {
              icon: 'settings',
              text: 'Settings',
              claims: [License.adminNo, License.corporateAdminNo],
              route: { name: 'settings' }
            },
            {
              icon: 'settings',
              text: 'Translations',
              claims: [License.adminNo, License.corporateAdminNo],
              route: { name: 'translations' }
            }
          ]
        },
        // Divider puts a divider below the object
        {
          icon: 'info',
          text: 'About',
          divider: true,
          route: { name: 'about' }
        }
      ]
    }
  },
  computed: {
    getAppName () {
      return process.env.VUE_APP_NAME
    },
    getSupportedLang () {
      return Lang.getSupportedLang()
    }
  },
  methods: {
    getUserName () {
      return Security.user.name
    },
    getCurrentFlag () {
      return Lang.getCurrentFlag()
    },
    setLang (lang) {
      Lang.setLang(lang)
    },
    // Upper right button on toolbar is designed to change
    // behavior depending on user state (logged in or not)
    toggleButton () {
      if (Security.user.loggedIn) {
        // If user is logged in, then button will log out user
        return 'logout'
      } else if (this.$route.name === 'about') {
        // If we are showing the about view and user is not
        // logged in, then button will log in user
        return 'login'
      }
      // Else button will go to about view
      return 'about'
    },
    hasAccess (item) {
      return Security.hasAccess(item.claims)
    },
    logout () {
      this.$root.$confirmLogout()
    },
    isAuthenticated () {
      return Security.user.loggedIn
    }
  },
  mounted () {
    // Only open the drawer if the screen is large, for better UX
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true
    }

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
  }
}
</script>

<style>
</style>
